import DetailMixinController from '@/mixins/DetailMixinController';
export default {
  name: 'CouponDetail',
  mixins: [DetailMixinController],
  mounted() {
    this.hasDelete = true
  },
  methods: {
    fetchPromise() {
      return this.$videoService.show(this.id)
    },
    prepareResponse(data) {
      return this.$videoService.prepareVideo(data)
    },
    deletePromise() {
      return this.$videoService.delete(this.id)
    }
  }
}